/**
 * Product promo popup + standalone promo countdown (header settings).
 */
(function () {
  function parsePromoDate(value, fallbackTime) {
    const raw = String(value || '').trim();
    if (!raw) return null;

    const normalized = raw.replace('T', ' ');
    const parts = normalized.split(/[\s]+/);
    const datePart = parts[0];
    const timePart = parts[1] || fallbackTime;

    if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return null;

    const [year, month, day] = datePart.split('-').map(Number);
    const timeBits = timePart.split(':');
    const hours = Number(timeBits[0] || 0);
    const minutes = Number(timeBits[1] || 0);
    const seconds = Number(timeBits[2] || 0);
    const date = new Date(year, month - 1, day, hours, minutes, seconds);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function readCountdownConfig() {
    if (window.ProductPromoCountdownConfig && window.ProductPromoCountdownConfig.endAt) {
      return window.ProductPromoCountdownConfig;
    }

    const configEl = document.getElementById('product-promo-countdown-config');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (e) {
      return null;
    }
  }

  if (!customElements.get('product-promo-countdown')) {
    class ProductPromoCountdown extends HTMLElement {
      connectedCallback() {
        const fromConfig = this.hasAttribute('data-from-config');
        let endAt = this.getAttribute('end-at');

        if (fromConfig || !endAt) {
          const config = readCountdownConfig();
          if (!config || !config.endAt) return;
          if (config.show === false && !fromConfig) return;
          endAt = config.endAt;
          this.setAttribute('end-at', endAt);
        }

        const end = parsePromoDate(endAt, '23:59:59');
        if (!end) return;

        const daysEl = this.querySelector('[data-days]');
        const hoursEl = this.querySelector('[data-hours]');
        const minutesEl = this.querySelector('[data-minutes]');
        const secondsEl = this.querySelector('[data-seconds]');
        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

        const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

        const tick = () => {
          const diff = end.getTime() - Date.now();
          if (diff <= 0) {
            daysEl.textContent = '00';
            hoursEl.textContent = '00';
            minutesEl.textContent = '00';
            secondsEl.textContent = '00';
            // Product page countdown stays visible at 00; popup countdown can hide/close.
            if (fromConfig) this.hidden = false;
            clearInterval(this._countdownTimer);
            this.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
            return;
          }

          const totalSeconds = Math.floor(diff / 1000);
          daysEl.textContent = pad(Math.floor(totalSeconds / 86400));
          hoursEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
          minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
          secondsEl.textContent = pad(totalSeconds % 60);
          this.hidden = false;
        };

        tick();
        this._countdownTimer = setInterval(tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this._countdownTimer);
      }
    }

    customElements.define('product-promo-countdown', ProductPromoCountdown);
  }

  if (!customElements.get('product-promo-popup')) {
    class ProductPromoPopup extends HTMLElement {
      connectedCallback() {
        this._onClose = this._close.bind(this);
        this.querySelectorAll('[data-popup-close]').forEach((el) => {
          el.addEventListener('click', this._onClose);
        });

        this.addEventListener('variant:added', this._onClose);
        this.addEventListener('countdown:ended', this._onClose);
        document.documentElement.addEventListener('keydown', this._onKeydown = (event) => {
          if (event.key === 'Escape' && this.hasAttribute('open')) this._close();
        });

        if (this.hasAttribute('data-design-mode')) {
          this._scheduleOpen();
          return;
        }

        if (!this._isInDateWindow() || this._isInCooldown()) return;
        this._scheduleOpen();
      }

      disconnectedCallback() {
        clearTimeout(this._openTimer);
        document.documentElement.removeEventListener('keydown', this._onKeydown);
      }

      _parseDate(value, fallbackTime) {
        return parsePromoDate(value, fallbackTime);
      }

      _isInDateWindow() {
        const now = new Date();
        const start = this._parseDate(this.getAttribute('start-at'), '00:00:00');
        const end = this._parseDate(this.getAttribute('end-at'), '23:59:59');

        if (start && now < start) return false;
        if (end && now > end) return false;
        return true;
      }

      _isInCooldown() {
        try {
          const stored = localStorage.getItem(this.getAttribute('storage-key') || 'theme:product-promo-popup');
          if (!stored) return false;
          const closedAt = parseInt(stored, 10);
          if (!closedAt) return false;
          const hours = parseFloat(this.getAttribute('reset-hours') || '24');
          return Date.now() - closedAt < hours * 60 * 60 * 1000;
        } catch (e) {
          return false;
        }
      }

      _scheduleOpen() {
        const delay = Math.max(0, parseInt(this.getAttribute('delay') || '5', 10)) * 1000;
        this._openTimer = setTimeout(() => this._open(), delay);
      }

      _open() {
        if (!this.hasAttribute('data-design-mode') && (!this._isInDateWindow() || this._isInCooldown())) return;
        this.setAttribute('open', '');
        document.documentElement.classList.add('lock-all');
      }

      _close() {
        this.removeAttribute('open');
        document.documentElement.classList.remove('lock-all');
        if (this.hasAttribute('data-design-mode')) return;
        try {
          localStorage.setItem(this.getAttribute('storage-key') || 'theme:product-promo-popup', String(Date.now()));
        } catch (e) {}
      }
    }

    customElements.define('product-promo-popup', ProductPromoPopup);
  }
})();
